export type SmartChargingAssetType = "charger" | "electric_vehicle"

export interface SmartChargingCompatibleAssetOem {
  slug: string
  displayName: string
  logoUrl?: string
}

export interface SmartChargingCompatibleAsset {
  id: string
  type: SmartChargingAssetType
  displayName: string
  oem: SmartChargingCompatibleAssetOem
}

export interface SmartChargingEligibilityResponse {
  id: number
  isEligible: boolean
  isSupportedSoon: boolean
}

export const SMART_CHARGING_ELIGIBILITY_OUTCOMES = [
  "eligible",
  "supportedSoon",
  "notSupported",
] as const

export type SmartChargingEligibilityOutcome =
  (typeof SMART_CHARGING_ELIGIBILITY_OUTCOMES)[number]

export interface SelectOption {
  value: string
  label: string
}

export const OTHER_OPTION_VALUE = "OTHER"
